export default __webpack_public_path__ + "static/media/Julienne Banza Ngoyi.eaa11e58.JPG";